import { FormattedMessage } from "react-intl";
// import { useLocale } from "../../contexts/LocaleContext";

export const Footer = () => {
  // const { setLocale, locale } = useLocale();

  return (
    <div className="two column row meta footer">
      <div className="centered sixteen wide column">
        <FormattedMessage id="text.cv_designed" />
      </div>
      {/* <div className="centered two wide column">
        <div className="ui buttons tiny basic">
          <button
            title="Russian"
            className={`ui icon button ${locale === "ru" ? "positive basic" : ""}`}
            onClick={() => setLocale("ru")}
          >
            <i aria-hidden="true" className="flag ru"></i>
          </button>
          <button
            title="English"
            className={`ui icon button ${locale === "en" ? "positive basic" : ""}`}
            onClick={() => setLocale("en")}
          >
            <i aria-hidden="true" className="flag gb uk"></i>
          </button>
        </div>
      </div> */}
    </div>
  );
};
